import { configureStore } from '@reduxjs/toolkit';

// Import slices when created
// import authReducer from './slices/authSlice';
// import orderReducer from './slices/orderSlice';

export const store = configureStore({
  reducer: {
    // auth: authReducer,
    // orders: orderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

